@if (navigationConfiguration$ | async; as navigationConfiguration) {
	@if (workspaceView$ | async; as workspaceView) {
		@if (mainService.navigationInProgress$ | async; as inProgress) {
			@if (inProgress) {
				<div class="progress">
					<div class="indeterminate"></div>
				</div>
			}
		}
		@if (getCurrentActions(navigationConfiguration); as currentActions) {
			@if ((navigationConfiguration.homeRoute || navigationConfiguration.parentRoute) && currentActions.length === 0) {
				<header class="main buttons">
					@if (navigationConfiguration.homeRoute) {
						<button
							[attr.title]="'home' | translate"
							[attr.aria-label]="'home' | translate"
							class="action"
							[routerLink]="getRouterLink(navigationConfiguration.homeRoute, navigationConfiguration)"
							role="button"
						>
							<i class="ico ico-home"></i>
						</button>
					}
					@if (navigationConfiguration.parentRoute) {
						<button
							[attr.title]="'up' | translate"
							[attr.aria-label]="'up' | translate"
							class="action"
							[routerLink]="getRouterLink(navigationConfiguration.parentRoute, navigationConfiguration)"
							role="button"
						>
							<i class="ico ico-arrow-up"></i>
						</button>
					}
					@if (isMainMenuEnabled(navigationConfiguration)) {
						<div class="action more">
							<stages-menu
								menuId="folderActionMenu"
								[noCollapse]="true"
								iconClasses="ico ico-more-vertical"
								[slim]="true"
								openTo="left"
								[items]="
									wrapMenuItems(
										$any(navigationConfiguration.folder),
										navigationConfiguration.mainMenu,
										navigationConfiguration
									)
								"
								[context]="navigationConfiguration.folder"
							/>
						</div>
					}
				</header>
			}
			@if (currentActions.length > 0) {
				<header class="main buttons">
					@for (action of currentActions; track trackByIndex($index)) {
						<button
							class="button sm {{ action.buttonClass }}"
							translate="{{ action.name }}"
							(click)="action.on()"
							[disabled]="inProgress || action.disabled()"
						></button>
					}
				</header>
			}
		}
		@if (
			getCurrentMode(navigationConfiguration.supportedModes, getActionParam(navigationConfiguration));
			as currentMode
		) {
			<nav [ngClass]="hasToolbar(navigationConfiguration)">
				@if (getSelection(navigationConfiguration, currentMode.isSelectEnabled); as selection) {
					<div class="wrapper">
						@if (navigationConfiguration.folder) {
							<!-- handle folder as array so we can use ngFor which works around a bug in routerLink active: https://github.com/angular/angular/issues/13865 -->
							@for (folder of [navigationConfiguration.folder]; track folder; let first = $first) {
								<ul class="list folder">
									<li
										class="list-item"
										[ngClass]="{ separator: first }"
										[class.active]="isRouterLinkActive(folder.route, folder.exact === true)"
										id="navItemf{{ folder.id }}"
									>
										<a
											class="label"
											[routerLink]="getRouterLink(folder.route, navigationConfiguration)"
											(click)="closeNavigationIfLeaf(folder)"
										>
											@switch (folder.entryType) {
												@case (singleLine) {
													<stages-navigation-entry-single-line [entry]="$any(folder)" [mode]="folder.displayMode" />
												}
												@case (twoLine) {
													<stages-navigation-entry-two-line [entry]="$any(folder)" [mode]="folder.displayMode" />
												}
												@case (twoLineSplitRating) {
													<stages-navigation-entry-two-line-split-rating
														class="fullsize"
														[entry]="$any(folder)"
														[mode]="$any(folder).displayMode"
													/>
												}
												@case (changeMarker) {
													<stages-navigation-entry-change-marker
														class="fullsize"
														[entry]="$any(folder)"
														[mode]="folder.displayMode"
													/>
												}
												@default {
													<stages-navigation-entry-single-line [entry]="$any(folder)" [mode]="folder.displayMode" />
												}
											}
										</a>
										@if (currentMode.isMenuEnabled) {
											<div class="action"></div>
										}
									</li>
								</ul>
							}
						}
						@if (currentMode.isSelectEnabled) {
							<ul class="list">
								<li class="list-item select-all">
									<div class="select">
										<input type="checkbox" class="checkbox" id="select-all-checkbox" [(ngModel)]="selection.all" />
										<label for="select-all-checkbox"></label>
									</div>
									<a class="label">
										<div class="text">
								<span class="h3" translate="select.all"></span>
										</div>
									</a>
								</li>
							</ul>
						}
						@if (currentMode.isRearrangeEnabled) {
							<ul class="list">
								<li class="list-item order">
									<div class="select"></div>
									<div class="label">
										<select
											name="order"
											id="order"
											(change)="onOrderChange($any($event.target).value, navigationConfiguration)"
										>
											<option
												value="alphabetical"
												translate="rearrange.order.az"
												[selected]="rearrangeOrder === 'alphabetical'"
											></option>
											<option
												value="custom"
												translate="rearrange.order.custom"
												[selected]="rearrangeOrder === 'custom'"
											></option>
										</select>
									</div>
								</li>
							</ul>
						}
						<ul class="list stages-sortable">
							@for (
								element of $any(
									getVisibleNavigationEntries(navigationConfiguration.list) | disabledFilter: workspaceView
								);
								track trackByIdAndAlphabeticalOrderToggle(i, element);
								let i = $index;
								let last = $last
							) {
								@if (!element.displayMode || element.displayMode === "VIEW") {
									<li
										class="list-item"
										[ngClass]="{ separator: !last && !isSingleLineDisplayed(element.entryType) }"
										[class.active]="
											isRouterLinkDisabled(currentMode) ? '' : isRouterLinkActive(element.route, element.exact === true)
										"
										id="navItem{{ element.id }}"
									>
										@if (currentMode.isSelectEnabled) {
											<div class="select">
												<input
													type="checkbox"
													class="checkbox"
													[(ngModel)]="selection.set[selection.keyFunction(element)]"
													(ngModelChange)="selection.onChange(element)"
													[disabled]="!isSelectable(element, currentMode.actionPermissionName)"
													id="e{{ element.id }}"
												/>
												<label for="e{{ element.id }}"></label>
											</div>
										}
										@if (currentMode.isRearrangeEnabled) {
											<div class="handle draggableAreaForSort">
												<i class="ico ico-handle"></i>
											</div>
										}
										@if (!element.linkDisabled) {
											<a
												class="label"
												[ngClass]="{ draggableAreaForSort: currentMode.isRearrangeEnabled }"
												[routerLink]="getRouterLink(element.route, navigationConfiguration, currentMode)"
												(click)="closeNavigationIfLeaf(element)"
											>
												@switch (element.entryType) {
													@case (singleLine) {
														<stages-navigation-entry-single-line
															class="fullsize"
															[entry]="element"
															[mode]="element.displayMode"
														/>
													}
													@case (twoLine) {
														<stages-navigation-entry-two-line
															class="fullsize"
															[entry]="element"
															[mode]="element.displayMode"
														/>
													}
													@case (twoLineSplitRating) {
														<stages-navigation-entry-two-line-split-rating
															class="fullsize"
															[entry]="element"
															[mode]="element.displayMode"
														/>
													}
													@case (changeMarker) {
														<stages-navigation-entry-change-marker
															class="fullsize"
															[entry]="element"
															[mode]="element.displayMode"
														/>
													}
													@default {
														<stages-navigation-entry-single-line
															class="fullsize"
															[entry]="element"
															[mode]="element.displayMode"
														/>
													}
												}
											</a>
										}
										@if (element.linkDisabled) {
											<div
												class="label"
												[ngClass]="{ draggableAreaForSort: currentMode.isRearrangeEnabled }"
												(click)="closeNavigationIfLeaf(element)"
											>
												@switch (element.entryType) {
													@case (singleLine) {
														<stages-navigation-entry-single-line
															class="fullsize"
															[entry]="element"
															[mode]="element.displayMode"
														/>
													}
													@case (twoLine) {
														<stages-navigation-entry-two-line
															class="fullsize"
															[entry]="element"
															[mode]="element.displayMode"
														/>
													}
													@case (twoLineSplitRating) {
														<stages-navigation-entry-two-line-split-rating
															class="fullsize"
															[entry]="element"
															[mode]="element.displayMode"
														/>
													}
													@case (changeMarker) {
														<stages-navigation-entry-change-marker
															class="fullsize"
															[entry]="element"
															[mode]="element.displayMode"
														/>
													}
													@default {
														<stages-navigation-entry-single-line
															class="fullsize"
															[entry]="element"
															[mode]="element.displayMode"
														/>
													}
												}
											</div>
										}
										@if (currentMode.isMenuEnabled) {
											<div class="action">
												<stages-menu
													menuId="elementActionMenu{{ i + 1 }}"
													[noCollapse]="true"
													iconClasses="ico ico-more-vertical"
													[slim]="true"
													openTo="left"
													[items]="wrapMenuItems(element, element.menuItems, navigationConfiguration)"
													[context]="element"
												/>
											</div>
										}
									</li>
								}
								@if (element.displayMode === "RENAME" || element.displayMode === "ADD") {
									<li
										class="list-item new-child"
										[class.active]="
											isRouterLinkDisabled(currentMode) ? '' : isRouterLinkActive(element.route, element.exact === true)
										"
										[id]="element.displayMode === 'ADD' ? 'new-child' : 'navItem' + element.id"
									>
										<div class="label new-child">
											<a
												[routerLink]="getRouterLink(element.route, navigationConfiguration, currentMode)"
												(click)="closeNavigationIfLeaf(element)"
											></a
											><!-- make router link active work during rename-->
											@switch (element.entryType) {
												@case ("single-line") {
													<stages-navigation-entry-single-line
														class="fullsize"
														[entry]="element"
														[mode]="element.displayMode"
													>
														<input
															id="{{ i + 1 }}-rename-input"
															type="text"
															stagesRestrictInput="\|"
															maxlength="255"
															[placeholder]="'process.navigation.add.child.placeholder' | translate"
															[ngModel]="element.label"
															(stagesKeyUp)="onEditInput($event, element, element.displayMode !== 'ADD')"
															(blur)="stopEditEntry(element, navigationConfiguration, $any($event))"
															[stagesAutofocus]
														/>
													</stages-navigation-entry-single-line>
												}
												@case ("two-line") {
													<stages-navigation-entry-two-line
														class="fullsize"
														[entry]="element"
														[mode]="element.displayMode"
													>
														<input
															id="{{ i + 1 }}-rename-input"
															type="text"
															stagesRestrictInput="\|"
															maxlength="255"
															[placeholder]="'process.navigation.add.child.placeholder' | translate"
															[ngModel]="element.label"
															(stagesKeyUp)="onEditInput($event, element, element.displayMode !== 'ADD')"
															(blur)="stopEditEntry(element, navigationConfiguration, $any($event))"
															[stagesAutofocus]
														/>
													</stages-navigation-entry-two-line>
												}
												@case ("two-line-split-rating") {
													<stages-navigation-entry-two-line-split-rating
														class="fullsize"
														[entry]="element"
														[mode]="element.displayMode"
													>
														<input
															id="{{ i + 1 }}-rename-input"
															type="text"
															stagesRestrictInput="\|"
															maxlength="255"
															[placeholder]="'process.navigation.add.child.placeholder' | translate"
															[ngModel]="element.label"
															(stagesKeyUp)="onEditInput($event, element, element.displayMode !== 'ADD')"
															(blur)="stopEditEntry(element, navigationConfiguration, $any($event))"
															[stagesAutofocus]
														/>
													</stages-navigation-entry-two-line-split-rating>
												}
												@default {
													<stages-navigation-entry-single-line
														class="fullsize"
														[entry]="element"
														[mode]="element.displayMode"
													>
														<input
															id="{{ i + 1 }}-rename-input"
															type="text"
															stagesRestrictInput="\|"
															maxlength="255"
															[placeholder]="'process.navigation.add.child.placeholder' | translate"
															[ngModel]="element.label"
															(stagesKeyUp)="onEditInput($event, element, element.displayMode !== 'ADD')"
															(blur)="stopEditEntry(element, navigationConfiguration, $any($event))"
															[stagesAutofocus]
														/>
													</stages-navigation-entry-single-line>
												}
											}
										</div>
										@if (currentMode.isMenuEnabled) {
											<div class="action">
												<stages-menu
													menuId="elementActionMenu{{ i + 1 }}"
													[noCollapse]="true"
													iconClasses="ico ico-more-vertical"
													openTo="left"
													[items]="wrapMenuItems(element, element.menuItems, navigationConfiguration)"
													[context]="element"
												/>
											</div>
										}
									</li>
								}
							}
							@if (hasOmmittedEntries(navigationConfiguration.list)) {
								<div class="label ommitted-items">
									<div class="text fullsize light">
								<span class="h3" translate="list.items.ommitted"></span>
								<span class="h6" [translate]="'list.items.ommitted.search.general'"></span>
									</div>
								</div>
							}
						</ul>
						<stages-support-section />
					</div>
				}
			</nav>
		}
		@if (showFloatingActionButton$ | async) {
			<stages-floating-action-menu
				[iconClass]="'ico ico-add'"
				[menuItems]="getMenuItemsForFloatingActionButton(navigationConfiguration)"
			/>
		}
		@if (isSimpleFloatingActionButtonVisible(navigationConfiguration)) {
			<stages-floating-action-menu
				mode="button"
				[iconClass]="'ico ico-add'"
				[menuItems]="getMenuItemsForFloatingActionButton(navigationConfiguration)"
			/>
		}
	}
}
